module.exports = __webpack_public_path__ + "static/thx-a902b3236f219ac242fa6d555c7a550a.jpg";